export default {
  brand: {
    label: 'Brand',
    required: true,
    valueKeys: ['$set', 'brand'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'brand-invalid',
        alertLevel: 'critical',
      },
    ],
    // lookup: {
    //   mapper: '',
    // },
  },
  idh: {
    label: 'IDH #',
    required: true,
    valueKeys: ['$set', 'idh'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-id-invalid',
        alertLevel: 'critical',
      },
    ],
    // lookup: {
    //   mapper: '',
    // },
  },
  n: {
    label: 'Product Name',
    required: true,
    valueKeys: ['$set', 'n'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'product-name-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  family: {
    label: 'Product Family',
    required: true,
    valueKeys: ['$set', 'family'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'family-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  sub_family: {
    label: 'Product Sub-Family',
    required: true,
    valueKeys: ['$set', 'sub_family'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'sub-family-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  market: {
    label: 'Market',
    required: true,
    valueKeys: ['$set', 'market'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'market-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  market_segment: {
    label: 'Market Segment',
    required: true,
    valueKeys: ['$set', 'market_segment'],
    filters: ['trim'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'market-segment-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  open_stock: {
    label: 'Is Open Stock?',
    required: false,
    valueKeys: ['$set', 'open_stock'],
    filters: ['trim', 'boolean'],
    validators: [],
  },
  holiday_special: {
    label: 'Is Holiday Special?',
    required: false,
    valueKeys: ['$set', 'holiday_special'],
    filters: ['trim', 'boolean'],
    validators: [],
  },
  key_initiative: {
    label: 'Is Key Initiative?',
    required: false,
    valueKeys: ['$set', 'key_initiative'],
    filters: ['trim', 'boolean'],
    validators: [],
  },
  year_round_deal: {
    label: 'Is Year Round Deal?',
    required: false,
    valueKeys: ['$set', 'year_round_deal'],
    filters: ['trim', 'boolean'],
    validators: [],
  },
};



// WEBPACK FOOTER //
// ./src/configs/etl/masterproducts/masterProductsColumnsConfig.js